export default "__VITE_ASSET__5911eddc__"